import { memo } from 'react';

import { IconButton, Row } from 'components/Blocks';

import { cn } from 'styles';

interface AlphabetProps {
  children?: never;
  setLetter: (letter: string) => void;
  letter: string;
}

const alphabet = ['#', ...'abcdefghijklmnopqrstuvwxyz'];

function Alphabet({ letter, setLetter }: AlphabetProps): JSX.Element {
  return (
    <Row className="overflow-x-auto tablet:justify-normal" justifyContent="center" gap="1">
      {alphabet.map((singleLetter) => (
        <IconButton
          key={`${singleLetter}--letter`}
          onClick={() => setLetter(singleLetter)}
          className={cn(
            'h-8 w-8 text-sm font-normal uppercase',
            singleLetter === letter && 'font-bold text-primary',
          )}
        >
          {singleLetter}
        </IconButton>
      ))}
    </Row>
  );
}

export default memo(Alphabet);
